/**
 * DrawerScrim — the dimmed full-screen backdrop the Create Workshop drawer
 * sits on. Clicking the backdrop requests a close; clicks inside the panel are
 * stopped so they do not travel to it.
 *
 * Its own file so the drawer declares one component (`react/no-multi-comp`) and
 * stays under the per-function line cap.
 */
import type { ReactNode } from 'react';

export function DrawerScrim({
  onScrimClick,
  children,
}: {
  onScrimClick: () => void;
  children: ReactNode;
}) {
  return (
    <div
      className="nb-dashboards nb-cdrawer-scrim"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 50,
        display: 'flex',
        justifyContent: 'flex-end',
        background: 'rgba(15, 25, 18, 0.35)',
      }}
      onClick={onScrimClick}
      role="presentation"
    >
      <div style={{ height: '100%' }} onClick={(e) => e.stopPropagation()}>
        {children}
      </div>
    </div>
  );
}
